import { render, staticRenderFns } from "./TypeOfBusinessManage.vue?vue&type=template&id=7a814433&"
import script from "./TypeOfBusinessManage.vue?vue&type=script&lang=js&"
export * from "./TypeOfBusinessManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports